import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroContenedorFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='N. CONTENEDOR' htmlFor='input-numeroContenedor' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroContenedor'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-numeroContenedor' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroContenedorFormGroup)
